// extracted by mini-css-extract-plugin
export default {"dropdown-menu-list":"de606a"};